import wormhole from "./wormhole.png?h=28bfb0941cccc1ab642a8a6041d67d96";

const Story = () => {
  return (
    <div
      className="container"
      data-aos="fade-up"
      data-aos-duration="1200"
      id="story"
    >
      <div className="row">
        <div className="col-12 col-md-6 d-flex pre">
          <div>
            <h3>The Story</h3>
            <h2>Travel, discover and many ROARs!</h2>
            <p>
              Lion Travelers are true adventure seekers led by their curiosity
              to see the world and beyond.
              <br />
              Through their journeys, they will discover secret codes which will
              allow them to seize stunning opportunities yet to be unveiled!
              <br />
              They will be collecting exclusive NFT resources and items of great
              power for their benefit.
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex pre">
          <div>
            <img
              id="wormhole"
              src={wormhole}
              loading="lazy"
              alt="A wormhole to the Dimension NFT"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;
